module.exports = __webpack_public_path__ + "check-contract.96ce0d625293ecf89d5a93e799266bda.png";